import { render, staticRenderFns } from "./interactive-gallery-item.vue?vue&type=template&id=67657844"
import script from "./interactive-gallery-item.vue?vue&type=script&lang=js"
export * from "./interactive-gallery-item.vue?vue&type=script&lang=js"
import style0 from "./interactive-gallery-item.vue?vue&type=style&index=0&id=67657844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,VCheckbox: require('/app/node_modules/vuetify/lib/components/VCheckbox/VCheckbox.js').default,GalleryPhoto: require('/app/components/ui/GalleryPhoto.vue').default,VChip: require('/app/node_modules/vuetify/lib/components/VChip/VChip.js').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VChip,VIcon})
